import { ApiNetWork } from "@/network/apiNet/apiNet";


// 用户反馈
export function encryptionCustomerBack(data) {
    return ApiNetWork.get("app/encryptionCustomerBack", data);
}

// 活动列表
export function activityList(data) {
    return ApiNetWork.get("app/activityList", data);
}
// 活动详情
export function activityDetail(data) {
    return ApiNetWork.get("app/activityDetail", data);
}
// 活动详情评论列表
export function activityCommentList(data) {
    return ApiNetWork.get("app/activityCommentList", data);
}
// 活动详情发布评论
export function activityComment(data) {
    return ApiNetWork.get("app/activityComment", data);
}
// 活动详情点赞
export function activityZan(data) {
    return ApiNetWork.get("app/activityZan", data);
}

// 积分明细
export function userScoreList() {
    return ApiNetWork.get("app/userScoreList");
}

// 查看我兑换的商品
export function myGiftOrderList(data) {
    return ApiNetWork.get("app/MyGiftOrderList", data);
}

// 添加地址
export function addGiftOrderInfo(data) {
    return ApiNetWork.get("app/addGiftOrderInfo", data);
}

// 分享页面
export function shareUserInfo(data) {
    return ApiNetWork.get("app/shareUserInfo", data);
}

// 邀请好友-配置
export function encryptionInvite() {
    return ApiNetWork.get("app/encryptionInvite", {});
}

// 邀请好友-好友记录
export function encryptionInviteResult() {
    return ApiNetWork.get("app/encryptionInviteResult", {});
}

// 邀请好友-话费兑换记录
export function encryptionInviteWithdrawResult() {
    return ApiNetWork.get("app/encryptionInviteWithdrawResult", {});
}

// 邀请好友-兑换话费
export function encryptionInviteWithdraw(data) {
    return ApiNetWork.get("app/encryptionInviteWithdraw", data);
}

// 获取用户信息
export function encryptionUserInfo() {
    return ApiNetWork.get("app/encryptionUserInfo", { });
}

// 获取抽奖信息
export function encryptionGetPrizeInfo() {
    return ApiNetWork.get("app/encryptionSpinPulse", {});
}

//查询每日任务完成情况
export function encryptionGetEverydayReward() {
    return ApiNetWork.get("app/encryptionSpinPulseAvail", {});
}

//抽奖接口
export function evcryptionSpinPulseGo() {
    return ApiNetWork.get("app/encryptionSpinPulseGo", {});
}

//兑换奖品
export function evcryptionExchangePrize(data) {
    return ApiNetWork.get("app/encryptionSpinPulseRedeem", data);
}

export function encryptionGetActiveAdInfo(data){
    return ApiNetWork.get("app/encryptionAd", data);
}

//竞猜比赛列表
export function encryptionGuessListInfo() {
    return ApiNetWork.get("app/encryptionGuess", {});
}

//竞猜下注接口
export function encryptionGuessJoin(data){
    return ApiNetWork.get("app/encryptionGuessJoin", data);
}

//竞猜记录
export function encryptionGuessOrderList() {
    return ApiNetWork.get("app/encryptionGuessOrder", {});
}